import Vue from "vue";
import Vue2TouchEvents from "vue2-touch-events";
import { APP_LOGGER } from "@/app/logger";

APP_LOGGER.debug("Install vue2-touch-events", { Vue2TouchEvents });
Vue.use(Vue2TouchEvents);
